import { apiService } from './api'
import {
  ComplianceRule,
  ComplianceRuleInput,
  ComplianceRulesResponse,
  ComplianceStatsResponse,
} from '../types/compliance'

export class ComplianceService {
  // 規範一覧取得
  async getRules(params?: {
    page?: number
    limit?: number
    category?: string
    search?: string
    isActive?: boolean
  }): Promise<ComplianceRulesResponse> {
    console.log('🌐 規範一覧API呼び出し:', { url: '/compliance', params })
    const result = await apiService.get<ComplianceRulesResponse>('/compliance', params)
    console.log('✅ 規範一覧API成功:', {
      rulesCount: result.rules?.length,
      total: result.pagination?.total,
    })
    return result

    // フォールバック機能を一時的に無効化
    // try {
    //   console.log('🌐 規範一覧API呼び出し:', { url: '/compliance', params });
    //   const result = await apiService.get<ComplianceRulesResponse>('/compliance', params);
    //   console.log('✅ 規範一覧API成功:', { rulesCount: result.rules?.length, total: result.pagination?.total });
    //   return result;
    // } catch (error) {
    //   console.error('❌ 規範一覧API失敗:', error);
    //   console.warn('APIが利用できません。デモデータを返します。');
    //   return this.getDemoRules(params);
    // }
  }

  // 規範詳細取得
  async getRule(id: string): Promise<ComplianceRule> {
    return await apiService.get<ComplianceRule>(`/compliance/${id}`)
  }

  // 規範作成
  async createRule(data: ComplianceRuleInput): Promise<{ message: string; rule: ComplianceRule }> {
    console.log('🌐 規範作成API呼び出し:', { url: '/compliance', data })
    const result = await apiService.post<{ message: string; rule: ComplianceRule }>(
      '/compliance',
      data
    )
    console.log('✅ 規範作成API成功:', { ruleId: result.rule?.id, title: result.rule?.title })
    return result
  }

  // 規範更新
  async updateRule(
    id: string,
    data: ComplianceRuleInput
  ): Promise<{ message: string; rule: ComplianceRule }> {
    return await apiService.put<{ message: string; rule: ComplianceRule }>(
      `/compliance/${id}`,
      data
    )
  }

  // 規範削除
  async deleteRule(id: string): Promise<{ message: string }> {
    return await apiService.delete<{ message: string }>(`/compliance/${id}`)
  }

  // カテゴリ一覧取得
  async getCategories(): Promise<{ categories: string[] }> {
    return await apiService.get<{ categories: string[] }>('/compliance/categories')
  }

  // カテゴリ作成
  async createCategory(
    categoryName: string,
    description?: string
  ): Promise<{ message: string; category: string }> {
    return await apiService.post<{ message: string; category: string }>(
      '/compliance/categories/create',
      {
        categoryName,
        description,
      }
    )
  }

  // 規範統計取得
  async getStats(): Promise<ComplianceStatsResponse> {
    return await apiService.get<ComplianceStatsResponse>('/compliance/stats')
  }

  private getDemoRules(params?: any): ComplianceRulesResponse {
    const demoRules: ComplianceRule[] = [
      {
        id: 'demo-rule-1',
        title: 'ハラスメント防止基本方針',
        description: '職場におけるハラスメント防止に関する基本的な方針とガイドライン',
        content:
          '当社では、すべての従業員が安心して働ける職場環境の維持のため、あらゆる形態のハラスメントを禁止します。',
        category: 'ハラスメント防止',
        isActive: true,
        version: 1,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
      {
        id: 'demo-rule-2',
        title: '情報セキュリティ管理規程',
        description: '会社の情報資産を保護するためのセキュリティ対策基準',
        content:
          '情報セキュリティの確保は企業活動の基盤であり、すべての従業員が遵守すべき重要な責務です。',
        category: '情報セキュリティ',
        isActive: true,
        version: 1,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
      {
        id: 'demo-rule-3',
        title: 'コンプライアンス基本規程',
        description: '企業倫理・コンプライアンス推進に関する基本的な規程',
        content:
          'コンプライアンスは単なる法令遵守にとどまらず、社会的責任を果たすための重要な取り組みです。',
        category: 'コンプライアンス基礎',
        isActive: true,
        version: 1,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ]

    // 簡単なフィルタリング
    let filteredRules = demoRules
    if (params?.category) {
      filteredRules = filteredRules.filter((rule) => rule.category === params.category)
    }
    if (params?.search) {
      filteredRules = filteredRules.filter(
        (rule) => rule.title.includes(params.search) || rule.description.includes(params.search)
      )
    }

    return {
      rules: filteredRules,
      pagination: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        total: filteredRules.length,
        pages: Math.ceil(filteredRules.length / (params?.limit || 10)),
      },
    }
  }
}

export const complianceService = new ComplianceService()
